import { allProfileTypes } from '../../constants/profileTypes';
import { getModesForCommunity, getReachableCommunities } from './modeHelpers';

export function getSession(state) {
  return state.session;
}

export function getUserProfile(state) {
  return getSession(state).profile;
}

export function getUser(state) {
  return getSession(state).user;
}

export function getUserCommunity(state) {
  const profile = getUserProfile(state);
  return profile != null ? profile.community : null;
}

export function getUserCommunityName(state) {
  const community = getUserCommunity(state);
  return community != null ? community.name : null;
}

export function getUserProfiles(state) {
  return getUser(state)?.profiles;
}

export function getUserUnits(state) {
  return state.session.units;
}

export function getUserUnitsForCurrentCommunity(state) {
  const userUnits = state.session.units || [];
  const currentCommunity = getUserCommunity(state);
  if (!currentCommunity) {
    return userUnits;
  }
  return userUnits.filter(unit => unit.community?.id === currentCommunity.id);
}

export function getLoggedUserAdminProfiles(state) {
  var profiles = getUserProfiles(state);
  return profiles.filter(
    profile => profile.admin || profile.type === allProfileTypes.ADMIN
  );
}

export function getSessionType(state) {
  return getSession(state).type;
}

export function getCommunityTimeZone(state) {
  return state.communities.timeZone;
}

export function getAvailableSessionModes(state) {
  const user = getUser(state);
  const community = getUserCommunity(state);
  if (!user || !community) {
    return [];
  }
  return getModesForCommunity(user, community.id);
}

export function canSwitchSessionMode(state) {
  return getAvailableSessionModes(state).length > 1;
}

export function getReachableCommunitiesFromSession(state) {
  const user = getUser(state);
  if (!user) {
    return [];
  }
  return getReachableCommunities(user);
}

export function isJustResident(state) {
  return getSessionType(state) === allProfileTypes.RESIDENT;
}

export function getUserDataForAccess(state) {
  return {
    personalId: {
      number: state.session.user.personalIdNumber,
      type: state.session.user.personalIdType
    },
    pin: state.session.user.pin,
    distresedPin: state.session.user.distressedPin
  };
}
